import {styledBox} from "../../../../../themes/architecture/styled-box";

/**
 * This is the "PAID" label shown above the amount at cold state
 */
export const JackpotWidgetAmountLabelBox = styledBox("JackpotWidgetAmountLabelBox");
